import UserService from "@services/user/UserService";
import { RootStore } from "@state/stores/types";
import { redirect } from "@state/utils";
import { THEME_SETTINGS } from "@theme-settings";
import { getCurrentCulture, isGamesTheme, UserTypes } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { action, observable } from "mobx";

class LogoutPopupStore {
	@observable isLogoutPopupActive: boolean = false;
	@observable isLogoutFromRealityCheck: boolean = false;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	public async displayLogoutOption() {
		if (THEME_SETTINGS.isLogoutPopupEnabled) {
			this.activatePopup();
			return;
		}

		await this.rootStore.userAuthStore.logoutUser();

		redirect(`/${getCurrentCulture()}/${DefaultPath.HOME}`);
	}

	@action.bound
	activatePopup() {
		this.isLogoutPopupActive = true;
	}

	@action.bound
	deactivatePopup() {
		this.isLogoutPopupActive = false;
	}

	@action.bound
	async deactivate() {
		this.rootStore?.realityCheckStore?.deactivatePopup();

		this.deactivatePopup();

		await UserService.deactivateUser(this.isLogoutFromRealityCheck);

		if (isGamesTheme()) {
			redirect(`/${getCurrentCulture()}/${DefaultPath.HOME}`);
		}
	}

	@action.bound
	async deactiveAndLogout() {
		this.rootStore?.realityCheckStore?.deactivatePopup();

		this.deactivatePopup();

		await UserService.deactivateUser(this.isLogoutFromRealityCheck);

		await this.rootStore.userAuthStore.logoutUser();

		redirect(`/${getCurrentCulture()}/${DefaultPath.HOME}`);
	}

	@action.bound
	public getUserTypeForDeactivate(): UserTypes {
		if (this.rootStore.userAuthStore.secondaryUser == null) {
			return UserTypes.PRIMARY;
		} else {
			if (this.rootStore.userAuthStore.isPrimaryUserOnline) {
				return UserTypes.PRIMARY;
			} else {
				return UserTypes.SECONDARY;
			}
		}
	}

	@action.bound
	setIsLogoutFromRealityCheck(isLogoutFromRealityCheck: boolean) {
		this.isLogoutFromRealityCheck = isLogoutFromRealityCheck;
	}

	@action.bound
	onDispose() {
		this.isLogoutPopupActive = false;
		this.isLogoutFromRealityCheck = false;
	}
}

export default LogoutPopupStore;
